import { GAMES, SITE } from '@cardengine/shared';
import { linkProps, usePath } from '../router.js';

/**
 * The site header: the name, and a link per game.
 *
 * Built from the games catalogue rather than a list kept here, so a new game
 * appears in the nav for the same reason it appears on the home page. The
 * hardcoded version had gone stale the moment Solitaire landed — it offered
 * Switch and not Solitaire, which reads as "Solitaire is the lesser one"
 * rather than "somebody forgot".
 *
 * Two things deliberately absent. There is no Home link: the name on the left
 * is one, and two ways to the same page is one more thing to read. And there
 * is no How to play, because each game has its own rules — a single global
 * link had to pick a game, and it silently picked Switch. The rules are one
 * click away on each game's own page, which is where you are when you want
 * them.
 *
 * `comingSoon` entries are skipped: they have no route to link to.
 */
export function SiteNav() {
  const path = usePath();
  const games = GAMES.filter((game) => game.status === 'available');

  return (
    <header className="nav">
      <a className="nav__brand" {...linkProps('/')}>
        <span className="nav__mark" aria-hidden="true">
          ♠
        </span>
        <span className="nav__name">{SITE.name}</span>
      </a>

      <nav className="nav__links" aria-label="Games">
        {games.map((game) => {
          // Also active on the game's rules page, which is still that game.
          const active = path === game.href || path.startsWith(`${game.href}/`);
          return (
            <a
              key={game.id}
              className={`nav__link ${active ? 'is-active' : ''}`}
              aria-current={active ? 'page' : undefined}
              {...linkProps(game.href)}
            >
              {game.name}
            </a>
          );
        })}
      </nav>
    </header>
  );
}
